import {
    defaultRuleIndicationOfDanger,
    defaultFilterRulesIndicationsOfDanger,
} from "./state";

/**
 * Mutación que establece las reglas de indicaciones de peligro de SGA.
 *
 * @param {*} state.rulesIndicationsOfDanger - Estado de las reglas de indicaciones de peligro de SGA.
 * @param rulesIndicationsOfDanger - Reglas de indicaciones de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setRulesIndicationsOfDangerSga(
    state,
    rulesIndicationsOfDanger
) {
    state.rulesIndicationsOfDanger = rulesIndicationsOfDanger;
}

/**
 * Mutación que establece la acción a realizar.
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar.
 * @return {void}
 * @author Brandon Torres
 */
export function setActionRuleIndicationOfDanger(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la regla de indicación de peligro por defecto.
 *
 * @param {*} state.ruleIndicationOfDanger - Estado de la regla de indicación de peligro.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultRuleIndicationOfDangerSga(state) {
    state.ruleIndicationOfDanger = defaultRuleIndicationOfDanger();
}

/**
 * Mutación que establece el filtro de las reglas de indicaciones de peligro de SGA por defecto.
 *
 * @param {*} state.filterRulesIndicationsOfDanger - Estado del filtro de las reglas de indicaciones de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterRulesIndicationsOfDanger(state) {
    state.filterRulesIndicationsOfDanger = defaultFilterRulesIndicationsOfDanger();
}

/**
 * Mutación que establece la cantidad de reglas de indicaciones de peligro por página.
 *
 * @param {*} state.filterRulesIndicationsOfDanger.per_page - Cantidad de registros por página.
 * @param {*} state.filterRulesIndicationsOfDanger.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterRulesIndicationsOfDanger = {
        ...state.filterRulesIndicationsOfDanger,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterRulesIndicationsOfDanger.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterRulesIndicationsOfDanger.page = page;
}

/**
 * Mutación que establece el paginador de registros de las reglas de indicaciones de peligro.
 *
 * @param {*} state.filterRulesIndicationsOfDanger.page - Página actual.
 * @param {*} state.filterRulesIndicationsOfDanger.per_page - Cantidad de registros por página.
 * @param {*} state.filterRulesIndicationsOfDanger.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateRulesIndicationsOfDangerSga(state, paginate) {
    state.filterRulesIndicationsOfDanger = {
        ...state.filterRulesIndicationsOfDanger,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la regla de indicación de peligro de SGA.
 *
 * @param {*} state.ruleIndicationOfDanger - Estado de la regla de indicación de peligro.
 * @param ruleIndicationOfDanger - Regla de indicación de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setRuleIndicationOfDangerSga(state, ruleIndicationOfDanger) {
    state.ruleIndicationOfDanger = {
        id: ruleIndicationOfDanger.id,
        name: ruleIndicationOfDanger.name,
        sga_danger_indication_code_combination_ids:
            ruleIndicationOfDanger.sga_danger_indication_code_combination_ids,
        sga_danger_indication_code_display_ids:
            ruleIndicationOfDanger.sga_danger_indication_code_display_ids,
    };
}
